import createSupabaseStore from './supabase-table-store'

export default () => createSupabaseStore(
  async (set, supabase, payload) => {
    const {data} = await supabase
      .from('projects_view')
      .select('*')
      .order('start', {ascending: false})
    ;

    set(data);
  },
  'projects',
  []
);